<template>
  <div>
    <wc-page-title v-if='wo' :loading='isLoading' :title='title' :subtitle='subtitle'>
      <template v-slot:appendSubtitle>
        <wc-is-capital-install
          :class=" 'ml-2 ' + ($vuetify.breakpoint.mdAndUp ? 'mt-n4' : 'mt-n2')"
          v-if='wo.project && wo.project_obj.project_detail && !wo.project_obj.project_detail.is_capital_system && wo.project_obj.division_obj.division === "Irrigation"'
        ></wc-is-capital-install>
      </template>
      <template v-slot:rightSide>
        <wc-parked-status-chip v-if="wo.park"></wc-parked-status-chip>
        <wo-timeline v-if='wo.timeline' :timeline='wo.timeline'></wo-timeline>
        <must-do-status v-if='wo' :wo='wo'></must-do-status>
        <wo-status v-if='wo' :wo='wo'></wo-status>
        <wc-burger-menu>
          <v-list-item @click='toggleHold' :disabled='wo.office_complete || wo.archived'>
            <v-list-item-icon>
              <v-icon :color='wo.on_hold ? "success" : "error"'>{{$icons.hold.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ wo.on_hold ? "Remove Hold" : "Put Work Order on hold"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='toggleArchive' :disabled='wo.office_complete || wo.status === "S"'>
            <v-list-item-icon>
              <v-icon color='error'>mdi-archive</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{wo.status === "S" ? "Unschedule to Archive" : "Toggle Archive"}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='togglePriorityStatus' v-if='showPriorityToggle' :disabled='wo.office_complete'>
            <v-list-item-icon>
              <v-icon :color="wo.timeline === '' ? 'error' : 'grey'">mdi-exclamation-thick</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if="wo.timeline === ''">Add Priority Status</v-list-item-title>
              <v-list-item-title v-else>Remove Priority Status</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click='toggleCompleteStatus' :disabled='wo.office_complete'>
            <v-list-item-icon>
              <v-icon :color="!wo.is_complete ? 'success' : 'error'">mdi-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-if='!wo.is_complete'>Mark Complete</v-list-item-title>
              <v-list-item-title v-else>Mark NOT Complete</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </wc-burger-menu>
      </template>
    </wc-page-title>
    <v-container v-if='wo && wo.on_hold'>
      <v-alert border='bottom' type='error' :icon='$icons.hold.icon'>This Work Order is on hold</v-alert>
    </v-container>
    <v-container v-if='wo && wo.archived'>
      <v-alert border='bottom' type='error'>This Work Order is archived (editing is disabled)</v-alert>
    </v-container>
    <router-view
      v-if='wo'
      :wo='wo'
      @update='update'
      @refresh='refresh'
    ></router-view>
  </div>
</template>

<script>
import WOStatus from '@/modules/wos/components/WOStatus';
import WCParkedStatus from '@/components/chips/WCParkedStatus';
import WOTimeline from '@/modules/wos/components/WOTimeline';
import WCIsCapitalInstall from '@/components/chips/WCIsCapitalInstall';
import MustDoStatus from './MustDoStatus';
import wosAPI from '@/modules/wos/api';
import trackerAPI from '@/api/tracker';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'wo-detail',
  data: () => ({
    isLoading: true,
    wo: null
  }),
  computed: {
     today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    title () {
      if (this.wo) {
        return this.wo.wo_type_display
      }
      return ''
    },
    subtitle () {
      if (this.wo) {
        if (this.wo.project && this.wo.project_obj.name) {
          return this.wo.project_obj.name + ' - ' + this.wo.project_obj.division_obj.division
        }
        if (this.wo.estimate && this.wo.estimate_obj.name) {
          return this.wo.estimate_obj.name + ' - ' + this.wo.estimate_obj.division_obj.division
        }
      }
      return ''
    },
    showPriorityToggle () {
      if (this.wo) {
        return this.wo.wo_type_obj.category === 'SC';
      }
      return false;
    },
    menu () {
      const side_menu = [
        {
          title: this.overview.title,
          icon: this.overview.icon,
          route: { name: 'WOOverview', params: { id: this.$route.params.id } }
        },
        {
          title: this.actionTracker.title,
          icon: this.actionTracker.icon,
          route: { name: 'WOActionTracker', params: { id: this.$route.params.id } }
        },
        {
          title: 'Product/Labour',
          icon: 'mdi-hammer-screwdriver',
          route: { name: 'WOProductLabour', params: { id: this.$route.params.id } }
        }
      ]

      if(this.wo.wo_type_obj.category === "IN"){
        side_menu.push(
          {
            title: 'Install Form',
            icon: 'mdi-form-select',
            route: { name: 'WOInstallForm', params: { id: this.$route.params.id } }
          }
        )
      }

      return side_menu;
    },
    timelineTooltip () {
      let ret = ''
      if (this.wo) {
        switch (this.wo.timeline) {
          case 'PRI':
            ret = 'Priority'
            break
          case 'BM8':
            ret = 'Before May 8'
            break
          default:
            ret = ''
        }
      }
      return ret
    },
    ...mapState({
      overview: state => state.icons.routes.overview,
      actionTracker: state => state.icons.routes.actionTracker,
    })
  },
  mounted () {
    this.getWO()
  },
  methods: {
    async getWO () {
      this.isLoading = true
      this.wo = await wosAPI.getWO(this.$route.params.id)
      this.$store.dispatch('loadSubnavTitle', this.wo.wo_type_display + ' WO')
      this.$store.dispatch('loadSubnav', this.menu)
      this.isLoading = false
    },
    async update (wo) {
      this.isLoading = true
      this.wo = await wosAPI.updateWO(wo)
      this.isLoading = false
    },
    refresh(wo) {
      this.wo = wo
    },
    toggleArchive () {
      this.wo.archived = !this.wo.archived;

      let description = '';
      description = this.wo.archived ? 'Work Order archived' : 'Work Order un-archived';

      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'work_order': this.wo.id
      }

      trackerAPI.createWorkOrderTracker(tracker);
      this.update (this.wo);
    },
    toggleHold () {
      this.wo.on_hold = !this.wo.on_hold

      let description = '';
      description = this.wo.on_hold ? 'Work Order placed on hold' : 'Hold status removed';

      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'work_order': this.wo.id
      }
      trackerAPI.createWorkOrderTracker(tracker);
      this.update (this.wo);
    },
    async toggleCompleteStatus () {
      this.isLoading = true;
      this.wo.is_complete = !this.wo.is_complete;
      if (this.wo.is_complete) {
        // If we are saying the WO is complete, then the is_attempted must be false
        this.wo.is_attempted = false;
        this.wo.date_completed = this.today;
        this.wo = await wosAPI.completeWO(this.wo);
      } else {
        this.wo.date_completed = null;
        this.wo = await wosAPI.updateWO(this.wo);
      }

      let description = '';
      description = this.wo.is_complete ? 'Work Order marked as complete by office.' : 'Work Order NOT complete by office';

      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'work_order': this.wo.id
      }
      trackerAPI.createWorkOrderTracker(tracker);
      this.isLoading = false;
    },
    togglePriorityStatus () {
      let description = '';
      
      if (this.wo.timeline === 'PRI') {
        this.wo.timeline = '';
        description = 'Removed PRIORITY status from work order.';
      } else {
        this.wo.timeline = 'PRI';
        description = 'Added PRIORITY status to work order.';
      }

      const tracker = {
          'tracker_data': {
            'description': description,
            'taken_by': this.$store.state.auth.profile.id,
            'action_date': moment().format('YYYY-MM-DD').toString(),
          },
          'work_order': this.wo.id
      }
      trackerAPI.createWorkOrderTracker(tracker);
      this.update (this.wo);
    }
  },
  components: {
    'wo-status': WOStatus,
    'wc-parked-status-chip': WCParkedStatus,
    'wo-timeline': WOTimeline,
    'must-do-status': MustDoStatus,
    'wc-is-capital-install': WCIsCapitalInstall
  }
}
</script>
